<template>
	<section class="success">
		<nav>
			<!--<my-nav @openHours="handleOpenHours"></my-nav>-->
		</nav>
		<div class="wrapper">
			<div class="success-content">
				<h1 class="heading">Order Successfully Placed.</h1>
				<h3 class="subheading">Your order number is: <span class="order-detail">{{ orderNumber }}</span></h3>
				<h3 class="subheading">An email with your order details has been sent to: <span class="order-detail">{{ userEmail }}</span></h3>
				<router-link to="/" tag="button" style="color:white;background-color:#D00016;" class="subheading">Back to Home</router-link>
			</div>
		</div>
	</section>
</template>

<script>
	import MyNav from './MyNav'

	export default {
		name: 'SuccessfulOrder',
		props: ['orderNumber', 'userEmail'],
		components: {
			MyNav
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/css/main';

	.success {
		height: 100vh;
		display: flex;
		justify-content: center;
		align-items: center;
		.heading {
			margin-bottom: 5%;
		}
		button.subheading {
			@include secondary-button;
		}
		.subheading {
			color: black;
			margin-bottom: 5%;
		}
		.order-detail {
			color: $primary-color;
			display: block;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/SuccessfulOrder.vue